import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M25,16.42l-2.59,2.63.3.3a1,1,0,0,1,0,1.44,1,1,0,0,1-1.42,0L18,17.44l-7.56,7.7c1.76-.14,3.66-.23,5.56-.23h1L19,25l1,.05c1.6.09,3.12.22,4.47.37,1.9.21,3.47.43,4.46.59H29a1,1,0,0,0,.17,0l.16,0a.72.72,0,0,0,.21-.12l.13-.08a.69.69,0,0,0,.16-.22.76.76,0,0,0,.08-.11A1,1,0,0,0,30,25V21.51Z"/><path d="M29.91,6.6a.76.76,0,0,0-.08-.11.69.69,0,0,0-.16-.22l-.13-.08a.72.72,0,0,0-.21-.12l-.16,0A1,1,0,0,0,29,6h-.15c-1,.16-2.56.38-4.46.59-1.35.15-2.87.28-4.47.37L19,7l-2,.07H16A88,88,0,0,1,3.15,6H3a1,1,0,0,0-.17,0l-.16,0a.72.72,0,0,0-.21.12l-.13.08a.69.69,0,0,0-.16.22.76.76,0,0,0-.08.11A1,1,0,0,0,2,7V25a1,1,0,0,0,.09.42.76.76,0,0,0,.08.11.69.69,0,0,0,.16.22l.13.08a.72.72,0,0,0,.21.12l.16,0A1,1,0,0,0,3,26h.15c.94-.15,2.4-.36,4.17-.56l10-10.15a1,1,0,0,1,1.42,0L21,17.61l3.29-3.35a1,1,0,0,1,1.42,0L30,18.63V7A1,1,0,0,0,29.91,6.6ZM9,16a2,2,0,1,1,2-2A2,2,0,0,1,9,16Z"/>';
export var PanoramaSVG = function PanoramaSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
PanoramaSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PanoramaSVG);